// dashboard/frontend/src/utils/entitlements.ts
/**
 * CrisisShield Frontend Feature Gating & Entitlements
 */

export const FEATURE_ENTITLEMENTS: Record<string, string[]> = {
  government: [
    'home', 'global_monitor', 'intelligence_center', 'alerts', 
    'posts', 'topics', 'analytics', 'narrative_map', 'simulation', 
    'brand_protection'
  ],
  news_media: [
    'home', 'intelligence_center', 'alerts', 'posts', 'topics', 'analytics'
  ],
  financial_services: [
    'home', 'intelligence_center', 'alerts', 'posts', 'topics', 
    'analytics', 'simulation', 'brand_protection', 'business_intelligence'
  ],
  enterprise_security: [
    'home', 'intelligence_center', 'alerts', 'posts', 'topics', 
    'analytics', 'brand_protection', 'business_intelligence'
  ],
  critical_infrastructure: [
    'home', 'global_monitor', 'intelligence_center', 'alerts', 
    'posts', 'topics', 'analytics', 'narrative_map', 'brand_protection'
  ],
  other: [
    'home', 'global_monitor', 'topics', 'analytics'
  ]
};

/**
 * Checks if a user's organization type has access to a specific feature/page.
 * Superadmins (isAdmin = true) automatically bypass gating.
 */
export function hasFeatureAccess(orgType: string | null | undefined, featureId: string, isAdmin: boolean = false): boolean {
  if (isAdmin) return true;
  if (!orgType) return false;
  const features = FEATURE_ENTITLEMENTS[orgType.toLowerCase()] || FEATURE_ENTITLEMENTS['other'];
  return features.includes(featureId);
}
